import { datadog, tradeLogger } from '@flipster/utils/datadog';

import type { ChartLoadReporter } from './chart-load-recorder';

const timingName = {
  shell_visible: 'chart_shell_visible',
  overlay_hidden: 'chart_overlay_hidden',
} as const;

export const createChartLoadReporter = (): ChartLoadReporter => {
  const sentPageTimings = new Set<keyof typeof timingName>();

  return {
    reportAttempt(summary) {
      try {
        tradeLogger.info('chart_load_attempt', { ...summary });
      } catch {
        // Observability must never interrupt the chart lifecycle.
      }
    },
    addTiming(stage) {
      try {
        // RUM timings are page-view offsets. Remounts (tab, breakpoint) must not overwrite them.
        if (sentPageTimings.has(stage)) return;
        sentPageTimings.add(stage);
        datadog.addTiming(timingName[stage]);
      } catch {
        // Observability must never interrupt the chart lifecycle.
      }
    },
  };
};

export const chartLoadReporter = createChartLoadReporter();
